import script from "./DashboardOverview.vue?vue&type=script&setup=true&lang=ts"
export * from "./DashboardOverview.vue?vue&type=script&setup=true&lang=ts"

import "./DashboardOverview.vue?vue&type=style&index=0&id=038cd8d5&lang=postcss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-038cd8d5"]])

export default __exports__